import React from 'react'
import logo from '../../../images/logo2.png'
import { useNavigate } from 'react-router-dom'

const Deconnexion = ({ _signOut }) => {
    let navigate = useNavigate()
    return (
        <div>
            <div className='text-center mx-auto w-50 mt-4'>
                <img src={logo} className='img-fluid' alt='image du logo' />
            </div>
            <div className='h1 text-center mt-5'>Se déconnecter</div>
            <div className='text-center mt-5'>
                <div className='btn btn-outline-info' onClick={() => [_signOut(), navigate('/')]}>DECONNEXION</div>
            </div>
        </div>
    )
}

export default Deconnexion